import {Component, OnInit, inject} from '@angular/core';
import {AssetsService} from "../../../services/assets.service";
import {JobsService} from '../../../services/jobs.service';
import {ServiceRequestsService} from '../../../services/service-requests.service';
import {ToastService} from '../../../services/toast.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {UserStorageService} from "../../../services/user-storage.service";

@Component({
  selector: 'app-service-request',
  templateUrl: './service-request.component.html',
  styleUrls: ['./service-request.component.css'],
  standalone: false
})
export class ServiceRequestComponent implements OnInit {
  locationId: any = null;
  locations: any[] = [];
  depotId: any = null;
  depots: any[] = [];
  currentUser: any;
  assets: any[] = [];
  isPopupVisible: boolean = false;
  loading: boolean = false;
  isDepotValid: boolean = true;
  isPdfExportRunning: boolean = false;

  private readonly jobService = inject(JobsService);
  private readonly assetsService = inject(AssetsService);
  private readonly serviceRequestService = inject(ServiceRequestsService);
  private readonly toastService = inject(ToastService);
  private readonly fb = inject(FormBuilder);
  private readonly userStorageService = inject(UserStorageService);

  public readonly masterFormGroup: FormGroup = this.fb.group({});

  ngOnInit() {
    this.getStoredData();
    this.getServiceRequestDepots();
    this.getLocations()
  }

  private async getStoredData(): Promise<void> {
    const storedData = this.userStorageService.getValue('serviceRequest');
    if (storedData) {
      try {
        const parsedData: any[] = JSON.parse(storedData);
        if (parsedData && parsedData.length > 0) {
          const assetsIds = parsedData.map(assets => String(assets.asset_id));
          const response = await this.assetsService.lookup(assetsIds)

          if (Array.isArray(response)) {
            const lookupRes = response;

            if (lookupRes != null) {
              this.assets = this.assets.concat(lookupRes);
              this.locationId = lookupRes[0].location_id;
            }
            let id = 0;
            for (let asset of this.assets) {
              asset.service_request_asset_number = id;
              id++;
            }
          }
        }
      } catch (error) {
      }
    }
  }


  getLocations() {
    this.jobService.getLocations().then((data: any) => {
      this.locations = data;
      if (this.locations.length == 1) {
        this.locationId = this.locations[0].location_id;
        this.filterChanged()
      }
    });
  }

  getServiceRequestDepots() {
    this.serviceRequestService.getServiceRequestDepots()
      .then((data: any) => this.depots = data);
  }

  async filterChanged() {
    this.assets = this.locationId ? [this.createEmptyAsset(0)] : [];
  }

  addAsset() {
    this.assets.push(this.createEmptyAsset(this.assets.length));
  }

  createEmptyAsset(assetNumber: number) {
    return {
      service_request_asset_number: assetNumber,
      id: assetNumber,
      serial_number: '',
      is_sn_unknown: 0,
      model_id: null,
      po_number: '',
      issue_description: '',
      accesory_included: 0,
      battery_sent_in: 0,
      power_cord_sent_in: 0,
      blind_shipping: 0,
      service_contract: 0,
      accessory: '',
      due: '',
      description: '',
      model_name: '',
      make_id: null,
      make_name: '',
      type_id: null,
      type_name: '',
      tracking_number: '',
      pm_preapproval: 0,
      pm_contract: 0,
      under_warranty: 0,
      attachments: [],
      is_new: true
    };
  }

  async submitRequest(createPdf: boolean) {
    if (!this.assets) {
      return;
    }
    let attachments: {}[] = [];

    for (let asset of this.assets) {
      if (asset.attachments && asset.attachments.length > 0) {
        for (let attachment of asset.attachments) {
          attachments.push({
            attachtmentBase64: attachment.url,
            fileName: attachment.fileName,
            service_request_asset_number: asset.service_request_asset_number,
          });
        }
      }
    }

    const assetsData = this.assets.map((val: any) => {
      return {
        id: val.asset_id != -1 ? val.asset_id : null,
        service_request_asset_number: val.service_request_asset_number,
        serial_number: val.serial_number,
        is_sn_unknown: val.is_sn_unknown === "False" || val.is_sn_unknown === false || val.is_sn_unknown === "0" ? 0 : 1,
        po_number: val.po_number,
        issue_description: val.issue_description,
        accesory_included: val.accesory_included ? 1 : 0,
        battery_sent_in: val.battery_sent_in ? 1 : 0,
        power_cord_sent_in: val.power_cord_sent_in ? 1 : 0,
        blind_shipping: val.blind_shipping ? 1 : 0,
        service_contract: val.service_contract,
        accessory: val.accessory,
        due: val.due,
        description: val.description,
        model: val.model_id != -1 ? val.model_id : null,
        model_name: val.model_name,
        make_id: val.make_id != -1 ? val.make_id : null,
        make_name: val.make_name,
        type_id: val.type_id != -1 ? val.type_id : null,
        type_name: val.type_name,
        tracking_number: val.tracking_number,
        pm_preapproval: val.pm_preapproval ? 1 : 0,
        pm_contract: val.pm_contract,
        under_warranty: val.under_warranty,
      }
    });

    this.loading = true;
    const response: any = await this.serviceRequestService.createServiceRequest(
      this.locations.find((l: { location_id: any; }) => l.location_id === this.locationId).customer_id,
      this.locationId,
      this.depotId,
      JSON.stringify(assetsData),
      attachments
    );
    this.loading = false;
    if (response.IsSuccess) {
      this.locationId = null;
      this.depotId = null;
      this.assets = [];
      this.toastService.showToast("Your Service Request has been successfully submitted. ", "success");
      this.userStorageService.removeValue("serviceRequest");
    }

    // If createPdf is true, call openPdf with the serviceRequestId
    if (createPdf && response.Data) {
      this.openPdf(response.Data);
    }
    this.closePopup();
  }

  openPdf(serviceRequestId: any) {
    this.isPdfExportRunning = true
    this.serviceRequestService.GetServiceRequestPdf(serviceRequestId).then((res: any) => {
      if (res) {
        window.open(res.Data.Url, '_blank');
        this.isPdfExportRunning = false
      }
    })
  }

  handleDeleteAsset(index: any) {
    this.assets.splice(index, 1);
  }

  validateForm(form: FormGroup): boolean {
    this.isDepotValid = this.depotId !== null;

    if (!form.valid) {
      for (let control in form.controls) {
        form.controls[control].markAsTouched();
      }
    }
    return form.valid && this.isDepotValid;
  }

  openSubmitPopup() {
    if (!this.validateForm(this.masterFormGroup)) {
      this.toastService.showToast("Required fields are missing. ", "error");
      return;
    }
    this.isPopupVisible = true;
  }

  closePopup() {
    this.isPopupVisible = false;
  }

  async submitRequestWithoutPdf() {
    await this.submitRequest(false);
  }

  async submitRequestWithPdf() {
    await this.submitRequest(true);
  }

  customSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.location_name.toLowerCase().includes(term) ||
      item.full_address.toLowerCase().includes(term);
  }

  depotChanged($event: any) {
    this.depotId = $event.toString();
  }
}
